import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function CARPMemberSearchForm(props) {
  const NAME = "NAME";
  const PHONE = "PHONE";
  const MEMBERSHIP_NUMBER = "MEMBERSHIP_NUMBER";

  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");
  const [postalCode, setPostalCode] = useState(
    props.currState.MemberLookup.postalCode || props.currState.postalCode || "",
  );
  const [phone, setPhone] = useState(
    props.currState.MemberLookup.phone || props.currState?.Number?.replace(/\D/g, "") || "",
  );
  const [membershipNumber, setMembershipNumber] = useState(
    props.currState.MemberLookup.membershipNumber || props.currState.membershipNumber || "",
  );
  const [lessThan7, setLessThan7] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("description.Name") },
    { key: PHONE, value: t("description.ConfirmCustomerPhoneNumber") },
    { key: MEMBERSHIP_NUMBER, value: t("description.MembershipNumber") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(props.currState.MemberLookup.searchType || "NAME");

  useEffect(() => {
    setFirstName(firstName);
    setLastName(lastName);
    setPhone(phone);
    setPostalCode(postalCode);
    setMembershipNumber(membershipNumber);
  }, [selectedSearchType]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        postalCode: postalCode,
        membershipNumber: membershipNumber,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (membershipNumber.length < 7 && selectedSearchType === MEMBERSHIP_NUMBER) {
      setLessThan7(true);
      return;
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        postalCode: postalCode,
        membershipNumber: membershipNumber,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const memberNumberLimit = (e) => {
    if (e.target.value.length > 7) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FIRST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="string"
                  placeholder={t("description.ConfirmCustomerFirstName")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder={t("description.ConfirmCustomerLastName")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*POSTAL CODE*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerPostalCode")}:</div>
                <input
                  type="string"
                  placeholder={t("description.ConfirmCustomerPostalCode")}
                  name="postalCode"
                  className="input form-control required"
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*PHONE*/}
          {selectedSearchType === PHONE && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerPhoneNumber")}
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
              {/* {lessThanEightVin && (
                <Alert severity="error">
                  {t("description.VinInputLessErrorMsg")}
                </Alert>
              )} */}
            </>
          )}

          {/*MEMBERSHIP NUMBER*/}
          {selectedSearchType === MEMBERSHIP_NUMBER && (
            <>
              <div className="group-1">
                <div className="label">{t("description.MembershipNumber")}:</div>
                <input
                  type="number"
                  placeholder="1234567"
                  name="membershipNumber"
                  className="input form-control required"
                  value={membershipNumber}
                  onChange={(e) => {
                    memberNumberLimit(e);
                    setMembershipNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
              {lessThan7 && <Alert severity="error">{t("description.MembershipNumberInputErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CARPMemberSearchForm;
